import React, { useState } from 'react';
import ReactPlayer from 'react-player'

import Credit from './Credit';

const path = process.env.PUBLIC_URL

function Video({ title, desc, subtitle, creditShow, setCreditShow }) {
  const [playing, setPlaying] = useState(false)
  return (
    <div className={`video ${creditShow ? "show" : ""}`}>
      <div className={playing ? "container specialHide" : "container"}>
        <ReactPlayer
          className="reactPlayer"
          url="https://player.vimeo.com/progressive_redirect/playback/855553273/rendition/1080p/file.mp4?loc=external&signature=df79bb35010c8da29d4a6d0ecb253bdb772a2d5ce83b5159afcc6391dc4a921d"
          width="calc(100% - 80px)"
          height="auto"
          controls={ playing }
          autoPlay={ false }
          muted={ false }
          pip={ false }
          playsinline={true}
          playing={playing}
          onPause={() => setPlaying(false)}
          config={ { file: {
            attributes: { poster: `${path}/video_cover.jpg`, preload: 'none'  },
          } } }
        />
        <div className='textWrapper'>
          <div className='subtitle'>{subtitle}</div>
          <h2>
            <div dangerouslySetInnerHTML={{ __html: title }} />
          </h2>
          <div className="content">
            <p>{desc}</p>
          </div>
          <div className="playButton">
            <button onClick={() => {setPlaying(true); }}><img src={`${path}/play.png`} alt=""/></button>
          </div>
        </div>
      </div>
      <div className="credit">
        <button style={{ position: "relative", zIndex: 4}} onClick={() => setCreditShow(!creditShow)}>
          <img src={`${path}/arrow.svg`} />
          <div className="credit__title">Credit</div>
        </button>
        <Credit show={creditShow} />
      </div>
    </div>
  );
}

export default Video;
